import { render, staticRenderFns } from "./job-link-worker.component.vue?vue&type=template&id=31ad5c7f"
import script from "./job-link-worker.component.ts?vue&type=script&lang=ts&external"
export * from "./job-link-worker.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports